<div class="banner-bredcrum">
  <section class="banner">
    <div #air id="air" class="air"></div>
    <div
      class="container-fluid d-flex text-light flex-nowrap flex-column justify-content-center align-items-center c-height 333"
    >
      <div class="custom-max-width">
        <div class="column slideInUp">
          <h5
            class="display-2 mb-3 text-right">
            {{ heading }}
          </h5>
          <p *ngIf="sub_heading != ''" class="text-center">{{ sub_heading }}</p>
        </div>
      </div>
    </div>
  </section>
  <div
    *ngIf="breadcrumbs && breadcrumbs.length > 0"
    class="222 d-flex flex-row flex-wrap bottom-0 custom-mx-5"
  >
    <div
      class="d-flex flex-row flex-nowrap align-items-center grey my-1"
      *ngFor="let item of breadcrumbs; let i = index"
    >
      <span *ngIf="i != 0" class="m-2 v4-color-white"><i class="fa-solid fa-angle-left"></i></span>
      <p-button class="e-s-btn"
        [styleClass]="'p-button-text headingbutton'"
        [routerLink]="'/all-data-view'"
        [queryParams]="{ id: item.id }"
      >
        {{ item.label }}
      </p-button>
    </div>
  </div>
</div>


